import React from "react";
import "./tituloStyle.scss";
import { Link } from "react-router-dom";


const TituloCaja = ({ titulo, clases, tipo, link, linkContent, funcion}) => {
  return (
    <div className={clases} function={funcion}>
      <div className={tipo}>
            {titulo} <Link to={link == null? "/": link}>{linkContent}</Link>
      </div>
    </div>
  );
};

export default TituloCaja;
